'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\n    margin-top:', 'px;\n    margin-bottom:', 'px;\n    margin-left:', 'px;\n    margin-right:', 'px;\n    text-align:', ';\n    font-family: ', ';\n    letter-spacing: ', ';\n    cursor: ', ';\n  \n    ', '\n'], ['\n    color: ', ';\n    margin-top:', 'px;\n    margin-bottom:', 'px;\n    margin-left:', 'px;\n    margin-right:', 'px;\n    text-align:', ';\n    font-family: ', ';\n    letter-spacing: ', ';\n    cursor: ', ';\n  \n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: ', ';\n    font-weight: ', ';\n    text-decoration: ', ';\n    font-style: ', ';\n    line-height: ', ';\n    white-space: pre-wrap;\n    display: inline;\n'], ['\n    font-size: ', ';\n    font-weight: ', ';\n    text-decoration: ', ';\n    font-style: ', ';\n    line-height: ', ';\n    white-space: pre-wrap;\n    display: inline;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: ', 'px;\n    font-weight: ', ';\n    text-decoration: ', ';\n    font-style: ', ';\n    line-height: ', 'px;\n    white-space: pre-wrap;\n    display: inline;\n'], ['\n    font-size: ', 'px;\n    font-weight: ', ';\n    text-decoration: ', ';\n    font-style: ', ';\n    line-height: ', 'px;\n    white-space: pre-wrap;\n    display: inline;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _formattedText = require('../formattedText');

var _formattedText2 = _interopRequireDefault(_formattedText);

var _text = require('../../../constants/text');

var _colors = require('../../../constants/colors');

var _sizes = require('../../../constants/sizes');

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PComponent = _styledComponents2.default.div(_templateObject, function (props) {
    if (props.disabled) return _colors.Colors.StrokeDark;
    if (props.error) return _colors.Colors.Error;
    if (props.warning) return _colors.Colors.Warning;
    if (props.inverse) return _colors.Colors.LightMode;
    if (props.success) return _colors.Colors.Success;
    if (props.color) return props.color;
    return _colors.Colors.SecondaryText;
}, function (_ref) {
    var top = _ref.top;
    return (0, _getSize2.default)(top);
}, function (_ref2) {
    var bottom = _ref2.bottom;
    return (0, _getSize2.default)(bottom);
}, function (_ref3) {
    var left = _ref3.left;
    return (0, _getSize2.default)(left);
}, function (_ref4) {
    var right = _ref4.right;
    return (0, _getSize2.default)(right);
}, function (_ref5) {
    var textAlign = _ref5.textAlign;
    return textAlign || 'center';
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.ParagraphLetterSpacing, function (_ref6) {
    var clickable = _ref6.clickable;
    return clickable ? 'pointer' : 'auto';
}, function (_ref7) {
    var listItem = _ref7.listItem;
    return listItem ? '\n           display: list-item;\n           list-style-type: disc;\n           list-style-position: inside;\n           ' : null;
});

var P1 = _styledComponents2.default.p(_templateObject2, _text.TextSizes.P1FontSize, function (_ref8) {
    var bold = _ref8.bold;
    return bold ? _text.TextSizes.WeightSemiBold : _text.TextSizes.WeightNormal;
}, function (_ref9) {
    var underline = _ref9.underline;
    return underline ? 'underline' : 'none';
}, function (_ref10) {
    var italic = _ref10.italic;
    return italic ? 'italic' : 'normal';
}, _text.TextSizes.P1LineHeight);

var P2 = _styledComponents2.default.p(_templateObject2, _text.TextSizes.P2FontSize, function (_ref11) {
    var bold = _ref11.bold;
    return bold ? _text.TextSizes.WeightSemiBold : _text.TextSizes.WeightNormal;
}, function (_ref12) {
    var underline = _ref12.underline;
    return underline ? 'underline' : 'none';
}, function (_ref13) {
    var italic = _ref13.italic;
    return italic ? 'italic' : 'normal';
}, _text.TextSizes.P2LineHeight);

var P3 = _styledComponents2.default.p(_templateObject2, _text.TextSizes.P3FontSize, function (_ref14) {
    var bold = _ref14.bold;
    return bold ? _text.TextSizes.WeightSemiBold : _text.TextSizes.WeightNormal;
}, function (_ref15) {
    var underline = _ref15.underline;
    return underline ? 'underline' : 'none';
}, function (_ref16) {
    var italic = _ref16.italic;
    return italic ? 'italic' : 'normal';
}, _text.TextSizes.P3LineHeight);

var P4 = _styledComponents2.default.p(_templateObject2, _text.TextSizes.P4FontSize, function (_ref17) {
    var bold = _ref17.bold;
    return bold ? _text.TextSizes.WeightSemiBold : _text.TextSizes.WeightNormal;
}, function (_ref18) {
    var underline = _ref18.underline;
    return underline ? 'underline' : 'none';
}, function (_ref19) {
    var italic = _ref19.italic;
    return italic ? 'italic' : 'normal';
}, _text.TextSizes.P4LineHeight);

var PCustom = _styledComponents2.default.p(_templateObject3, function (_ref20) {
    var fontSize = _ref20.fontSize;
    return fontSize;
}, function (_ref21) {
    var bold = _ref21.bold;
    return bold ? _text.TextSizes.WeightSemiBold : _text.TextSizes.WeightNormal;
}, function (_ref22) {
    var underline = _ref22.underline;
    return underline ? 'underline' : 'none';
}, function (_ref23) {
    var italic = _ref23.italic;
    return italic ? 'italic' : 'normal';
}, function (_ref24) {
    var lineHeight = _ref24.lineHeight;
    return lineHeight;
});

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: 'getStyledComponent',
        value: function getStyledComponent() {
            var text = _react2.default.createElement(_formattedText2.default, { text: this.props.text });

            var size = this.props.size;
            if (!size) {
                size = _sizes.Sizes.md;
            }

            var component = null;
            switch (size) {
                case _sizes.Sizes.xl:
                    component = _react2.default.createElement(
                        P4,
                        { key: Math.random().toString(), bold: this.props.bold, italic: this.props.italic, underline: this.props.underline, className: this.props.className, title: this.props.title },
                        text
                    );
                    break;
                case _sizes.Sizes.lg:
                    component = _react2.default.createElement(
                        P1,
                        { key: Math.random().toString(), bold: this.props.bold, italic: this.props.italic, underline: this.props.underline, className: this.props.className, title: this.props.title },
                        text
                    );
                    break;
                case _sizes.Sizes.md:
                    component = _react2.default.createElement(
                        P2,
                        { key: Math.random().toString(), bold: this.props.bold, italic: this.props.italic, underline: this.props.underline, className: this.props.className, title: this.props.title },
                        text
                    );
                    break;
                case _sizes.Sizes.sm:
                    component = _react2.default.createElement(
                        P3,
                        { key: Math.random().toString(), bold: this.props.bold, italic: this.props.italic, underline: this.props.underline, className: this.props.className, title: this.props.title },
                        text
                    );
                    break;
                default:
                    component = _react2.default.createElement(
                        PCustom,
                        { key: Math.random().toString(), bold: this.props.bold, italic: this.props.italic, underline: this.props.underline, fontSize: this.props.fontSize, lineHeight: this.props.lineHeight, className: this.props.className, title: this.props.title },
                        text
                    );
                    break;
            }
            return component;
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.text || this.props.text === "" || this.props.text === " ") {
                return null;
            }
            return _react2.default.createElement(
                PComponent,
                {
                    key: Math.random().toString(),
                    inline: this.props.inline,
                    textAlign: this.props.textAlign,
                    color: this.props.color,
                    top: this.props.top,
                    bottom: this.props.bottom,
                    left: this.props.left,
                    right: this.props.right,
                    inverse: this.props.inverse,
                    error: this.props.error,
                    warning: this.props.warning,
                    listItem: this.props.listItem,
                    success: this.props.success,
                    disabled: this.props.disabled,
                    className: this.props.className,
                    bold: this.props.bold,
                    italic: this.props.italic,
                    underline: this.props.underline,
                    clickable: this.props.clickable
                },
                this.getStyledComponent()
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;